export class AbstractIdbaRequestModel {
    program: string;
    procedure: string;
    parameters: {};

    constructor(){
        this.procedure = "main"; 
        this.parameters = {} 
    };
}
